import type { Except, Merge } from 'type-fest';
import { useField } from '../../../hooks/useField';
import {
    type BooleanOrNullableBoolean,
    Controlled_BooleanInput,
    type Controlled_BooleanInputProps,
} from '../../inputs/controlled/Controlled_BooleanInput';

export type Form_BooleanInputProps<T extends object, N extends boolean> = Merge<
    Except<
        Controlled_BooleanInputProps<N>,
        keyof useField.Result<BooleanOrNullableBoolean<N>>
    >,
    useField.Props<BooleanOrNullableBoolean<N>, T>
>;

export const Form_BooleanInput = <T extends object, N extends boolean>({
    name,
    control,
    onChange,
    ...props
}: Form_BooleanInputProps<T, N>) => {
    const fieldProps = useField({
        name,
        control,
        onChange,
    });

    return (
        <Controlled_BooleanInput
            {...props}
            {...fieldProps}
        />
    );
};
